import gsap, { Power0, Cubic, Power2 } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from '../../lib/SplitToText';
import useSnapState from '../../hooks/useSnapState';
gsap.registerPlugin(ScrollTrigger, SplitText);

function createTwoColumnsImageTextScrollAnimation({
  scrollContainerRef,
  mainImageRef,
  mainTitleRef,
  ctaLinkRef,
  firstColumnRef,
}) {
  let onScrollDownTimeline = onScrollUpAnimation({
    scrollContainerRef,
    mainImageRef,
    mainTitleRef,
    ctaLinkRef,
  });

  let onScrollUpTimeline = onScrollDownAnimation({
    scrollContainerRef,
    mainImageRef,
    mainTitleRef,
    ctaLinkRef,
    firstColumnRef,
  });

  return [onScrollUpTimeline, onScrollDownTimeline];
}

function onScrollDownAnimation({
  scrollContainerRef,
  mainImageRef,
  firstColumnRef,
}) {
  // let tl = gsap
  //   .timeline({
  //     scrollTrigger: {
  //       scroller: `#container-snap-scroller`,
  //       trigger: scrollContainerRef.current,
  //       start: `55% center`,
  //       end: `80% center`,
  //       scrub: true,
  //     },
  //     id: 'onScrollDownAnimationTwoColumnsImageText',
  //     yoyo: true,
  //   })
  //   .add(rightColumnFadeUp(mainImageRef))
  //   .add(
  //     rightColumnFadeUp(firstColumnRef, { duration: 0.3 }, { duration: 0.5 }),
  //     '<40%',
  //   );
  // return tl;
}

function rightColumnFadeUp(mainImageRef, customOptionsOpacity, customOptionsY) {
  let tl = gsap.timeline({ id: 'rightColumnFadeUp' });

  tl.to(mainImageRef.current, {
    opacity: 0,
    ease: Power2.easeOut,
    duration: 0.8,
    ...customOptionsOpacity,
  }).to(
    mainImageRef.current,
    {
      y: -550,
      opacity: 0,
      ease: Power2.easeOut,
      duration: 1.3,
      ...customOptionsY,
    },
    '<20%',
  );

  return tl;
}

function onScrollUpAnimation({
  scrollContainerRef,
  mainImageRef,
  mainTitleRef,
  ctaLinkRef,
}) {
  const isSnapActive = useSnapState();

  let scrollTriggerParams = {};

  if (isSnapActive) {
    scrollTriggerParams.scroller = `#container-snap-scroller`;
  }

  let tl = gsap
    .timeline({
      scrollTrigger: {
        trigger: scrollContainerRef.current,
        start: 'top bottom',
        end: `center 55%`,
        once: true,
        id: 'scrollUpAnimation',
        ...scrollTriggerParams,
      },
      autoRemoveChildren: true,
    })
    .add(fadeInUpImage(mainImageRef))
    .add(lineHeightTitleAnimation(mainTitleRef), '<')
    .add(
      fadeInUpImage(
        ctaLinkRef,
        { duration: 0.3, ease: Power2.easeIn },
        { y: 100, duration: 1, ease: Cubic.easeOut },
        'fadeInpuImageCta',
      ),
      '<40%',
    )
    .add(
      fadeInUpImage(
        scrollContainerRef.current.getElementsByTagName('p')[0],
        { duration: 0.3, ease: Power2.easeIn },
        { y: 100, duration: 1, ease: Cubic.easeOut },
        'fadeInpuImage',
      ),
      '<10%',
    );

  return tl;
}

function fadeInUpImage(
  imageRef,
  customOptionsOpacity,
  customOptionsY,
  customId,
) {
  const tl = gsap.timeline({
    id: `TwoColumnImageText` + customId,
    autoRemoveChildren: true,
  });

  let targetRef = imageRef && imageRef.current ? imageRef.current : imageRef;

  return tl
    .from(targetRef, {
      opacity: 0,
      duration: 1,
      ease: Power0.easeOut,
      ...customOptionsOpacity,
    })
    .from(
      targetRef,
      {
        x: 0,
        y: 250,
        duration: 1,
        ease: Cubic.easeOut,
        ...customOptionsY,
      },
      '<',
    );
}

function lineHeightTitleAnimation(mainTitleRef) {
  const tl = gsap.timeline({ id: 'animations', autoRemoveChildren: true });
  const titleRef = mainTitleRef.current;

  return tl
    .from(
      mainTitleRef.current,
      {
        opacity: 0,
        duration: 1.4,
        ease: Power2.easeIn,
      },
      '<',
    )
    .from(
      mainTitleRef.current,
      {
        y: 130,
        duration: 1.7,
        ease: Power2.easeInOut,
      },
      '<',
    );
}

export default createTwoColumnsImageTextScrollAnimation;
